import toast from 'utils/toast'
import institutionAPI from 'services/institutionAPI'

export default async function decodeAfacodes({ data }: any) {
  const response = await institutionAPI({
    url: '/citizen-portal/geo/afacodes/decode',
    method: 'POST',
    data,
  })

  if (!response?.header?.success) {
    toast.error(response?.header?.message)
  }

  return response
}
